<template>
  <div class="index-header-page">
    <div class="index-header-top">
      <div class="index-header-top-box">
        <div class="index-header-content-left">
          <img @click="$router.push('/index')" class="index-header-content-left-img"
               src="../../../public/static/index-logo.png"/>
          <div class="index-header-content-left-role">{{ $t('cargo') }}</div>
        </div>
        <div class="index-header-content-right">
          <a-space>
            <a-badge v-if="!$store?.state?.isVisitor" :count="noticeCount" @click="$router.push('/notice')">
              <div class="index-header-content-right-help-box">
                  <a-icon type="bell" />
              </div>
            </a-badge>
            <div class="index-header-content-right-help-box" @click="gotoHelp">
              <a-icon type="question-circle" />
            </div>
            <div class="index-header-content-right-language-box">
              <a-dropdown>
                <div>
                  <img class="flag" :src=langImg[this.$i18n.locale] />
                  {{ langText }}
                  <a-icon type="down"/>
                </div>
                <template #overlay>
                  <a-menu>
                    <a-menu-item @click="changeLang('zh')">
                      <span :class="{active: $i18n.locale === 'zh'}" >{{ $t('langCh') }}</span>
                    </a-menu-item>
                    <a-menu-item @click="changeLang('en')">
                      <span :class="{active: $i18n.locale === 'en'}" >{{ $t('langEng') }}</span>
                    </a-menu-item>
                    <a-menu-item @click="changeLang('ru')">
                      <span :class="{active: $i18n.locale === 'ru'}">{{ $t('langRus') }}</span>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </div>
            <div class="index-header-content-right-tourist" @click="gotoLogin"  v-if="$store?.state?.isVisitor">
              {{ $t('indexLoginButton') }}
            </div>
            <div v-else class="index-header-content-right-user-box">
              <a-dropdown>
                <a-space class="">
                  <img src="../../../public/static/icon/admin.svg"/>
                  {{ $store?.state?.userInfo?.USER_NAME }}
                  <a-icon type="caret-down"/>
                </a-space>
                <a-menu slot="overlay" @click="accountMenu">
                  <a-menu-item key="changePwd">
                    <span>{{ $t('changePassword') }}</span>
                  </a-menu-item>
                  <a-menu-item v-if="sysType.OPER_STUATS === 1" key="changeRole">
                    <span>{{ $t('changeContainerRole') }}</span>
                  </a-menu-item>
                  <a-menu-item key="logout">
                    <span>{{ $t('logOut') }}</span>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </a-space>

        </div>
      </div>
    </div>
    <div class="index-header-bottom" v-if="$route.path !== '/aboutUs' && !$store?.state?.isVisitor">
      <div class="index-header-content">
        <div class="index-header-left">
          <div class="dol-menu-index" v-if="$store.state.userInfo">
            <a-menu
                class="mainMenu"
                mode="horizontal"
                style="background: #1F6CBA;"
                :theme="theme"
                :selectedKeys="selectMenu"
                @click="linkPage"
            >
              <template v-for="item in menuTree">
                <a-menu-item :key="item.ASSEMBLY">{{ $dt(item, 'MENU_NAME') }}</a-menu-item>
              </template>
            </a-menu>
          </div>
        </div>
      </div>
    </div>


    <a-modal :title="$t('changePassword')" v-model.trim="passwordDialog" :okText="$t('confirm')" :cancelText="$t('cancel')"
             :confirmLoading="changePwdLoading"
             @ok="changePwd">
      <dol-form-model :model="passwordForm" :rules="passwordValidateRules" ref="passwordForm">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('oldPassword')"
                               prop="oldPassword">
              <a-input v-model.trim="passwordForm.oldPassword" type="password"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('newPassword')"
                               prop="newPassword">
              <a-input v-model.trim="passwordForm.newPassword" type="password"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('confirmPassword')"
                               prop="confirmPassword">
              <a-input v-model.trim="passwordForm.confirmPassword" type="password"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </dol-form-model>
      <!--      <a-form class="editForm">
              <dol-form-item label="旧密码">
                <a-input v-model.trim="passwordForm.oldPassword" type="password" />
              </dol-form-item>
              <dol-form-item label="新密码">
                <a-input v-model.trim="passwordForm.newPassword" type="password" />
              </dol-form-item>
              <dol-form-item label="确认密码">
                <a-input v-model.trim="passwordForm.confirmPassword" type="password" />
              </dol-form-item>
            </a-form>-->
    </a-modal>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import moment from "moment";

export default {
  name: "indexHeader",
  data() {
    return {
      theme: 'dark',
      langText: this.$t('langCh'),
      passwordDialog: false,
      passwordForm: {},
      noticeCount: [],
      changePwdLoading: false,
      passwordValidateRules: {
        oldPassword: [{required: true, message: this.$t('pleaseEnterTheOldPassword'), trigger: ['blur', 'change']}],
        newPassword: [{required: true, message: this.$t('pleaseEnterANewPassword'), trigger: ['blur', 'change']}],
        confirmPassword: [{
          required: true,
          message: this.$t('pleaseConfirmTheNewPassword'),
          trigger: ['blur', 'change']
        }],
      },
      langImg: {
        'zh': require("../../../public/static/icon/flag-CN.png"),
        'en': require("../../../public/static/icon/flag-UK.png"),
        'ru': require("../../../public/static/icon/flag-RU.png")
      },
      moment
    }
  },
  computed: {
    ...mapState(['menuTree']),
    langObj() {
      return {
        zh: this.$t('langCh'),
        en: this.$t('langEng'),
        ru: this.$t('langRus')
      }
    },
    menuList() {
      let firstMenu = this.menuTree.find(item => new RegExp('^' + item.ASSEMBLY + '/').test(this.$route.path));
      return firstMenu?.children;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    selectMenu: {
      get() {
        return ['/' + this.$route.path.split('/')[1]];
      },
      set() {

      },
    },
    sysType() {
      let type = '';
      this.$store?.state?.sysList?.forEach(item => {
        if (item.SYS_CODE === 20011002) {
          type = item
        }
      })
      return type
    },
  },
  methods: {
    gotoHelp() {
      this.$router.push('/help/helpCenter')
    },
    gotoLogin() {
      let url = '/login';
      this.$router.replace(url).then(() => {
        this.$store.dispatch('logout')
      });
    },
    linkPage({key}) {
      let pickMenu = this.menuTree.find(item => item.ASSEMBLY === key);

      let getFirstPage = (menu) => {
        if (menu.children.length > 0) {
          return getFirstPage(menu.children[0])
        } else {
          return menu;
        }
      }

      let page = getFirstPage(pickMenu);

      this.$goPath(page);
    },
    gotoCompany() {
      if (!(this.userInfo?.OPER_STATUS)) {
        this.$router.push('companyRegister')
      } else if (this.userInfo?.OPER_STATUS === 20031003) {
        this.$router.push('/company/company')
      } else {
        this.$router.push('/registerDetail')
      }
    },
    changePwd() {
      this.$refs.passwordForm.validate(val => {
        if (val) {
          if (this.passwordForm.newPassword === this.passwordForm.confirmPassword) {
            this.changePwdLoading = true;
            let commonParams = {
              USER_ID: this.userInfo.USER_ID,
              PASSWORD: this.passwordForm.oldPassword,
              NEW_PASSWORD: this.passwordForm.newPassword,
            }
            this.$h5Api({
              type: '2020',
              data: [commonParams],
              showMessage: true,
            }).then(({data, total}) => {
              this.passwordDialog = false;
              this.$message.info(this.$t('modifySuccessfully'));
            }).finally(() => {
              this.changePwdLoading = false;
            })
          } else {
            this.$message.info(this.$t('theTwoPasswordEntriesAreInconsistent'));
          }
        }
      })
    },
    accountMenu({key}) {
      switch (key) {
        case 'changePwd':
          this.passwordForm = {};
          this.passwordDialog = true;
          break;
        case 'logout':
          let url = '/login';
          this.$router.replace(url).then(() => {
            this.$store.dispatch('logout')
          });
          break;
        case 'changeRole':
          this.gotoContainer()
          break;
      }
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
      this.$set(this, 'langText', this.langObj[lang] || this.$t('langCh'));
      localStorage.setItem('lang', lang)
      moment.locale(lang === 'zh' ? 'zh-cn' : lang);
      this.$moment.locale(lang === 'zh' ? 'zh-cn' : lang);
    },
    gotoContainer() {
      window.open(`/container-container/index?USER_ID=${this.$store.state.userInfo.USER_ID}`, "_blank", '', false);
    },
    getNoticeCount() {
      let data = {
        "GET_HEAD": [
          {
            "GET_METHOD": 3,
            "GET_TABLE":
                "SELECT COUNT(*)" +
                "  FROM GT_REMIND_MESSAGE M" +
                "  LEFT JOIN GM_SYS_DIC GSD ON M.MSG_TYPE = GSD.DIC_CODE" +
                "  LEFT JOIN GM_SYS_DIC GSD2 ON GSD.DIC_CODE_DESC =" +
                "  CONVERT(VARCHAR(50), GSD2.DIC_CODE)" +
                "  LEFT JOIN GT_REMIND_TEMPLATE R ON M.MSG_TYPE = R.MSG_TYPE" +
                " WHERE M.STATUS = 0"
          }],
        "GET_FILTER": [{
          "FILTER_FIELD": "M.TARGET_BY",
          "FILTER_TYPE": "4",
          "FILTER_VALUE1": this.userInfo.USER_ID,
          "FILTER_VALUE2": " "
        }, {"FILTER_FIELD": "R.NOTIFY_OBJECT ", "FILTER_TYPE": "4", "FILTER_VALUE1": 20011003, "FILTER_VALUE2": ""}]
      }
      this.$h5Api({
        type: '1001',
        data: [data],
        loading: false,
      }).then(({data}) => {
        this.noticeCount = data?.DATA_LIST[0]?.Column1
      })
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.$store.state.userInfo?.COMPANY_ID) {
        this.getNoticeCount();
      }
      this.changeLang(this.$i18n.locale)
    }, 500)
  },
}
</script>

<style lang="scss">
.index-header-page {
  position: sticky;
  z-index: 10;
  top: 0;

  .index-header-top {
    background: #FFFFFF;
    border-bottom: 1px solid #EEEEEE;

    .index-header-top-box {
      width: 1200px;
      margin: 0 auto;
      height: 56px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .index-header-content-left {
        display: flex;
        align-items: center;

        .index-header-content-left-img {
          width: 180px;
          cursor: pointer;
          margin-bottom: 10px;
        }
        .index-header-content-left-role{
          color: #FFFFFF;
          font-size: 12px;
          margin-left: 16px;
          padding: 0 4px;
          background: linear-gradient(134deg, #64B1FF 0%, #2A8FF7 100%);
          border-radius: 3px;
        }
        .index-header-content-left-title {
          font-size: 18px;
          font-weight: 600;
          margin-right: 20px;
          color: #333333;
        }
      }

      .index-header-content-right {
        display: flex;
        align-items: center;
        flex-direction: row;
        .index-header-content-right-help-center{
          display: flex;
          align-items: center;

          .index-header-content-right-help-icon{
            color: #333333;
            font-size: 14px;
            margin-right: 4px;

          }
          .index-header-content-right-help-icon:hover{
            color: #1F6CBA;
            cursor: pointer;
          }
          .index-header-content-right-help-icon-text{
            color: #333333;
          }
          .index-header-content-right-help-icon-text:hover{
            color: #1F6CBA;
            cursor: pointer;
          }
        }


        .language {
          margin-left: 5px;
          display: flex;
          align-items: center;
          color: rgba(255, 255, 255, 0.5000);

          span {
            font-size: 16px;

            &.active {
              color: #DDDDDD;
            }
          }
        }

        .index-top-content-right-title {
          font-size: 16px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5000);

        }
        .index-header-content-right-help-box{
          display: flex;
          align-items: center;
          padding: 9px;
          border: 1px solid #EEEEEE;
          border-radius: 20px;
          cursor: pointer;
          font-size: 16px;

        }
        .index-header-content-right-help-box:hover{
          color: #1F6CBA;
        }


        .index-header-content-right-language-box{
          display: flex;
          align-items: center;
          padding: 6px 14px 6px 8px;
          margin-right: 4px;
          border: 1px solid #EEEEEE;
          border-radius: 20px;
          cursor: pointer;
          .flag{
            margin-right: 4px;
            border-radius: 50%;
            width: 24px;
            height: 24px;
          }
          .language-name{
            margin: 0 6px;
          }
          svg{
            font-size: 12px;
          }
        }
        .index-header-content-right-language-box:hover{
          color: #1F6CBA;
        }
        .index-header-content-right-tourist{
          display: flex;
          align-items: center;
          padding: 8px 14px;
          background-color: #F2F6FA;
          border-radius: 20px;
          cursor: pointer;
        }
        .index-header-content-right-tourist:hover{
          color: #4C89C8;
        }
        .index-header-content-right-user-box{
          display: flex;
          align-items: center;
          padding: 6px 14px 6px 8px;
          background-color: #F2F6FA;
          border-radius: 20px;
          cursor: pointer;
          span{
            margin: 0 6px;
          }
          svg{
            font-size: 12px;
          }
          .ant-space-item{
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            max-width: 96px;
          }
        }
        .index-header-content-right-user-box:hover{
          color: #4C89C8;
        }
        .index-header-user-border {
          color: #FFFFFF;
          font-size: 14px;
          display: flex;
          align-items: center;

          .index-header-go-login {
            color: #999999;
            font-size: 14px;
            cursor: pointer;
          }

          .index-header-user-avatar {
            background-color: #2A8FF7;
            font-size: 12px;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }

  .index-header-bottom {
    background-color: #1F6CBA;

    .index-header-content {
      width: 1200px;
      margin: 0 auto;
      height: 46px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #1F6CBA;


      .index-header-left {
        display: flex;
        align-items: center;

        .index-header-logo {
          color: #1F6CBA;
          margin-right: 25px;
          width: 170px;
        }

        .dol-menu-index {
          .ant-menu.ant-menu-dark .ant-menu-item-selected {
            background: rgba(0, 0, 0, 0.1800);
          }

        }

        .index-header_left-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 16px;
          font-weight: 700;
          color: #333333;

          div {
            margin-left: 40px;
            padding: 5px 0;
            cursor: pointer;
          }
        }
      }

      .index-header-right {
        display: flex;
        align-items: center;
        color: rgba(206, 198, 198, 0.5);

        .index-header_right-user {
          margin-left: 32px;
          height: 60px;
          padding: 0 14px;
          color: #FFFFFF;
          font-size: 12px;
          font-weight: 400;
          line-height: 17px;

          .index-header-user-border {
            color: #FFFFFF;
            font-size: 14px;
            display: flex;
            align-items: center;

            .index-header-go-login {
              color: #999999;
              font-size: 14px;
              cursor: pointer;
            }

            .index-header-user-avatar {
              background-color: #2A8FF7;
              font-size: 12px;
              display: flex;
              align-items: center;
            }
          }

          div {
            cursor: pointer;
          }
        }

        .index-header_right-divider {
          height: 13px;
          margin: 0 15px;
        }

        .index-header_right-info {
          color: #1F6CBA;
          font-size: 16px;

          span {
            cursor: pointer;
          }
        }

        span {
          font-size: 16px;
          cursor: pointer;
          line-height: 1;
          font-weight: 700;

          &.active {
            color: #333333;
          }
        }
      }
    }
  }


  &.content-page{
    .index-header-top{
      border-bottom: 1px solid #EEEEEE;
      .index-header-top-box{
        width: auto;
        //min-width: 1400px;
        margin: 0 24px;
      }
    }
    .index-header-bottom{
      .index-header-content{
        width: auto;
        //min-width: 1400px;
        margin: 0 24px;
      }
    }
  }
}
</style>